<hsg-modal>
    <span class="title">פנייה למוקד התמיכה</span>
    <div class="body">
      <p>
       קיימת עבורך פניה פתוחה לנציג שירות לשם סיוע בהתחברות לאזור המידע האישי.
       <br>
       האם ברצונך לבטל את הפנייה?
      </p>
    </div>
    <div class="actions">
      <button hsg-button kind="primary" (click)="closeOpenCalls(0)">לא
        <!-- <hsg-spinner *ngIf="pending" class="u-mr-s"></hsg-spinner> -->
      </button>
    </div>
    <div class="right">
        <button hsg-button kind="primary" (click)="closeOpenCalls(1)">כן</button>
    </div>
  </hsg-modal>